import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Eye } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const VisionPage = () => {
    // Scroll to top when page loads
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="bg-[#0f172a] text-gray-200 min-h-screen relative overflow-hidden">

            {/* Background Effects */}
            <div className="fixed inset-0 pointer-events-none">
                <div className="absolute top-0 right-0 -mr-20 w-[800px] h-[800px] bg-cyan-500/10 rounded-full blur-[120px] opacity-30" />
                <div className="absolute bottom-0 left-0 -ml-20 w-[600px] h-[600px] bg-purple-500/10 rounded-full blur-[100px] opacity-30" />
            </div>

            <Navbar />

            <main className="pt-32 pb-20 px-6 relative z-10">
                <div className="container mx-auto">

                    {/* Title Section */}
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        className="text-center mb-20"
                    >
                        <span className="inline-block py-1 px-3 rounded-full bg-cyan-500/10 border border-cyan-500/20 text-cyan-400 text-xs font-semibold mb-6 tracking-wide">
                            HAKKIMIZDA
                        </span>
                        <h1 className="text-3xl md:text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-white via-cyan-100 to-emerald-200 mb-6 font-heading leading-tight">
                            Geçmişten Geleceğe<br />
                            <span className="text-cyan-500">Kültür Elçileri</span>
                        </h1>
                    </motion.div>

                    {/* VİZYON CONTENT */}
                    <div id="vizyon" className="mb-24 relative max-w-5xl mx-auto">
                        <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/20 to-emerald-500/20 blur-3xl rounded-full opacity-20 transform scale-y-50" />
                        <motion.div
                            initial={{ opacity: 0, scale: 0.95 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.8 }}
                            className="bg-white/5 backdrop-blur-2xl border border-white/10 rounded-[2.5rem] p-8 md:p-16 relative overflow-hidden shadow-2xl"
                        >
                            <div className="absolute top-0 right-0 w-64 h-64 bg-cyan-400/10 rounded-full blur-3xl -mr-32 -mt-32" />

                            <div className="flex flex-col md:flex-row items-center gap-12 relative z-10">
                                <div className="flex-shrink-0">
                                    <div className="w-24 h-24 rounded-3xl bg-gradient-to-br from-cyan-400 to-blue-600 flex items-center justify-center shadow-lg shadow-cyan-500/30">
                                        <Eye className="w-12 h-12 text-white" />
                                    </div>
                                </div>
                                <div className="text-center md:text-left">
                                    <h2 className="text-xl md:text-2xl font-bold text-white mb-6 font-heading">
                                        Vizyonumuz
                                    </h2>
                                    <p className="text-base md:text-lg text-gray-200 leading-relaxed font-light italic">
                                        "Muğla Sıtkı Koçman Üniversitesi Turist Rehberliği Topluluğu (TURET) olarak vizyonumuz; kültürel mirasa duyarlı, etik değerlere bağlı, akademik bilgi ile saha deneyimini bütünleştiren, ulusal ve uluslararası düzeyde yetkin turist rehberleri yetiştirilmesine katkı sağlayan, alanında örnek gösterilen bir öğrenci topluluğu olmaktır."
                                    </p>
                                </div>
                            </div>
                        </motion.div>
                    </div>

                </div>
            </main>


        </div>
    );
};

export default VisionPage;
